import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";
import ImageUrl from "components/app/image-url/ImageUrl";
import SearchBar from "components/app/search-bar/SearchBar";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Loader, Minus, Plus, X } from "lucide-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  isDailogAddProductRecommended: boolean;
  setIsDailogAddProductRecommended: (value: boolean) => void;
  editItemShopProduct: any;
  setEditItemShopProduct: any;
}
export default function DailogAddProductRecommended({ isDailogAddProductRecommended, setIsDailogAddProductRecommended, editItemShopProduct, setEditItemShopProduct }: DialogProps) {
  //*==================Store Glogbal State===============
  const { token } = useAppSelector((state) => state.auth);
  //*===============Function==================
  const onSubmitProductRecommeded = async () => {
    try {
      let url: string = "";
      url = RouteApi.getShopProductRecommended;
      url += `token=${token}`;
      const pyaload = {
        product_id: editItemShopProduct.product_id,
        search_text: searchTextInput,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        setItemProductRecommeded(response.user_shop_products);
      }
    } catch (error) {
      AppLog.show({
        message: `[onSubmitProductRecommeded]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };
  const onSubmitUpdateShopProductRecommended = async (id: any) => {
    setLoadingSubmitUpdateProductRecommeded(true);
    try {
      let url: string = "";
      url = RouteApi.submitUpdateShopProductRecommended;
      url += `token=${token}`;
      const pyaload = {
        product_id: editItemShopProduct.product_id,
        shop_id: shopId,
        recommend_product_id: id,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        setLoadingSubmitUpdateProductRecommeded(false);
        console.log(response, "response data");
        if (response.user_shop_product_rec) {
          setEditItemShopProduct((prevItemGroups: any) => {
            // Ensure modifiers is an array (convert from object or undefined)
            const recommended = Array.isArray(prevItemGroups.recommended_products) ? prevItemGroups.recommended_products : [];
            return {
              ...prevItemGroups,
              recommended_products: [...recommended, response.user_shop_product_rec],
            };
          });
        }
      }
    } catch (error) {
      setLoadingSubmitUpdateProductRecommeded(false);

      AppLog.show({
        message: `[onSubmitUpdateShopProductRecommended]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };
  const onSubmitDeleteShopProductRecommended = async (id: any) => {
    setLoadingSubmitDeleteProductRecommeded(true);
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopProductRecommended;
      url += `token=${token}`;
      const pyaload = {
        product_id: editItemShopProduct.product_id,
        shop_id: shopId,
        recommend_product_id: id,
      };
      const response = await RequestApi(url, { data: pyaload });
      if (response.status === "success") {
        setLoadingSubmitDeleteProductRecommeded(false);
      }
    } catch (error) {
      setLoadingSubmitDeleteProductRecommeded(false);

      AppLog.show({
        message: `[onSubmitDeleteShopProductRecommended]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
    }
  };
  //*===============Variable==================

  const [loadingSubmitUpdateProductRecommeded, setLoadingSubmitUpdateProductRecommeded] = useState<boolean>(false);
  const [loadingSubmitDeleteProductRecommeded, setLoadingSubmitDeleteProductRecommeded] = useState<boolean>(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [itemProductRecommeded, setItemProductRecommeded] = useState<any>([]);
  const [idRecommendedDelete, setIdRecommendedDelete] = useState(null);
  const [idRecommendedUpdate, setIdRecommendedUpdate] = useState(null);
  //*===============Ueffect==================
  useEffect(() => {
    onSubmitProductRecommeded();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTextInput, editItemShopProduct, idRecommendedDelete]);
  useEffect(() => {
    if (itemProductRecommeded?.is_recommended) {
      setItemProductRecommeded(itemProductRecommeded?.is_recommended);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog open={isDailogAddProductRecommended}>
      <DialogContent isShowBtnXClose={false} className="custom-dialog-class flex flex-col justify-between max-w-[1000px] h-[calc(100vh-80px)] ">
        <DialogHeader>
          <DialogTitle>Add Item Recommendation </DialogTitle>
          <DialogDescription>Search your product or search, click "Add" to Recommendation Products</DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => {
              setIsDailogAddProductRecommended(false);
            }}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className=" w-full gap-3  h-full">
          <div className="flex flex-col pe-3">
            <div className="sticky top-0 bg-white dark:bg-[#020817] left-0 py-2 px-1 z-10 ">
              <div className="flex-1">
                <div className="relative">
                  <SearchBar
                    onValueChange={(value) => {
                      setSearchTextInput(value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="grid lg:grid-cols-5  gap-y-3 gap-x-2 mt-4 z-[1] ">
              {itemProductRecommeded?.data?.map((item: any, index: number) => {
                return (
                  <div key={index} className="relative z-1 w-full max-w-sm border rounded-lg cursor-pointer">
                    {item.status === "Unpublished" && (
                      <div className="absolute flex justify-center items-center py-1 px-2 z-10 top-0 right-0 bg-red-600 text-white  rounded-bl-md rounded-tr-md mt-0">
                        <span className="text-[10px] ">{item.status}</span>
                      </div>
                    )}
                    {item.is_recommended === 0 ? (
                      <label
                        className="absolute opacity-80 p-1 mx-auto z-50 top-2 left-2 text-white group bg-blue-500  font-semibold cursor-pointer rounded-full 
                                                                                                          w-8 h-8 flex items-center justify-center text-md  "
                      >
                        {" "}
                        {loadingSubmitUpdateProductRecommeded === true && idRecommendedUpdate === item.product_id ? (
                          <Loader className="animate-spin w-4 h-4" />
                        ) : (
                          <Plus
                            onClick={() => {
                              setIdRecommendedUpdate(item.product_id);
                              onSubmitUpdateShopProductRecommended(item.product_id);
                            }}
                            className="w-4 h-4"
                          />
                        )}
                      </label>
                    ) : (
                      <label className="absolute opacity-80 p-1 mx-auto z-50 top-2 left-2 text-white group bg-red-500  font-semibold cursor-pointer rounded-full                                                                                             w-8 h-8 flex items-center justify-center text-md  ">
                        {" "}
                        {loadingSubmitDeleteProductRecommeded === true && idRecommendedDelete === item.product_id ? (
                          <Loader className="animate-spin w-4 h-4" />
                        ) : (
                          <Minus
                            onClick={() => {
                              setIdRecommendedDelete(item.product_id);
                              onSubmitDeleteShopProductRecommended(item.product_id);
                            }}
                            className="w-4 h-4"
                          />
                        )}
                      </label>
                    )}

                    <div className=" w-full relative overflow-hidden aspect-square  ">
                      <ImageUrl className="rounded-t-md cursor-pointer w-full h-full object-cover " src={item.picture} alt="" />
                    </div>
                    <div className={`p-4 `}>
                      <h5 className="text-md font-semibold line-clamp-1 overflow-hidden  ">{item?.local_description}</h5>
                      <p className=" font-semibold text-lg  text-red-500 "> {item.unit_price}</p>
                    </div>

                    {/* <div className=" w-full relative overflow-hidden  ">
                      <ImageUrl
                        className="rounded-t-md cursor-pointer object-cover "
                        src={item.picture}
                        alt=""
                      />
                    </div> */}
                    {/* <div className="py-2 px-2">
                      <h5 className="text-sm font-semibold line-clamp-2 overflow-hidden   ">
                        {item?.local_description}
                      </h5>
                      <p className=" font-semibold text-sm  text-red-500 ">
                        {" "}
                        {item.unit_price}
                      </p>
                    </div> */}
                  </div>
                );
              })}
            </div>
          </div>
          <ScrollBar orientation="vertical" />
        </ScrollArea>
        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
